
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'

import { Button, Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Collapse, Typography, Paper, IconButton, TablePagination, Grid, Checkbox, Box, Stack } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { loaderService } from '../../common/custom-loader/loader-service';
import { useTranslation } from 'react-i18next';
import { BaseURL } from '../../common/URLs';
import { HELPDESK_ROLES } from '../../common/constants';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { DeleteIcon, EditIcon, FAQIcon } from '../../common/icons';
import abeplLogo from "../../images/abeplLogo.png";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { toast } from 'react-toastify';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import apiClient from '../../axios';

function ReportsPage() {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [expandedSection, setExpandedSection] = useState({});
  const [managefaqdata, setmanagefaqdata] = useState([]);
  const [managefaqdatapdf, setmanagefaqdatapdf] = useState([]);
  const auth = 'Bearer ' + getLocalStorageItem('id_token');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [hideEdit, setHideEdit] = useState(getLocalStorageItem('role') === HELPDESK_ROLES.HelpdeskAdminUser || getLocalStorageItem('role') === HELPDESK_ROLES.SMUSer ? false : true)
  const [selectedFaqIds, setSelectedFaqIds] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editValues, setEditValues] = useState({
    id: "",
    fqaQuestion: "",
    fqaAnswer: "",
    grievanceCategory: "",
    grevanceSubCategory: "",
    isActive: "Y",
    extFlag: 0
  });

  const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
  const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
  const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
   const [isApiCalled, setIsApiCalled] = useState(false);

  const [logConfirmModalOpen2, setLogConfirmModalOpen2] = useState(false);
  const handleConfirmLogModalOpen2 = () => setLogConfirmModalOpen2(true);
  const handleConfirmLogModalClose2 = () => setLogConfirmModalOpen2(false);

  useEffect(() => {
    managefaq();
    managefaq1();
  }, [])

  const managefaq1 = () => {
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getAllHelpdeskFrequentAskQuestion",
      {},
      {
        headers: {
          "Authorization": auth
        },
      }
    ).then((response) => {
      if (localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser || localStorage.getItem('role') === HELPDESK_ROLES?.ExternalSupportExecutive) {
        let data = response.data.filter(item => item.extFlag === 1);
        setmanagefaqdatapdf(data);
      }
      else {
        let data = response.data.filter(item => item.extFlag === 0);
        setmanagefaqdatapdf(data);
      }
      loaderService.hideLoader();
    }).catch((error) => {
      console.log("Error - " + error);
      loaderService.hideLoader();
    })
  }

  const managefaq = () => {
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getAllFAQBaseOnCategory",
      {},
      {
        headers: {
          "Authorization": auth,
          "extFlag": (localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser || localStorage.getItem('role') === HELPDESK_ROLES?.ExternalSupportExecutive) ? 1 : 0
        },
      }
    ).then((response) => {
      setmanagefaqdata(response.data);
      loaderService.hideLoader();
    }).catch((error) => {
      console.log("Error - " + error);
      loaderService.hideLoader();
    })
  }

  const MyDoc = () => {
    const doc = new jsPDF()
    doc.addImage(abeplLogo, 'png', 85, 3, 20, 20, 'logo')
    doc.text('', 10, 20);
    autoTable(doc, { html: '#my-table' })
    autoTable(doc, {
      startY: 30,
      head: [['Catagory', 'Sub-catagory', 'FAQ', 'FAQA']],
      body: [
        ...managefaqdatapdf.map((row) => [row.grievanceCategory, row.grevanceSubCategory, row.fqaQuestion, row.fqaAnswer])
      ],
    })
    doc.save('ABEPL_FAQs.pdf')
  }

  const searchInObject = (obj, query) => {
    if (!obj || typeof obj !== "object") return false;
    return Object.values(obj).some((value) => {
      if (value == null) return false;
      if (typeof value === "string" || typeof value === "number") {
        return value.toString().toLowerCase().includes(query.toLowerCase());
      }
      if (typeof value === "object") return searchInObject(value, query);
      return false;
    });
  };

  // Highlight matching text
  const highlightText = (text, query) => {
    if (!query || !text) return text;
    const regex = new RegExp(`(${query})`, "gi");
    return text.split(regex).map((part, i) =>
      part.toLowerCase() === query.toLowerCase() ? (
        <span key={i} style={{ backgroundColor: "yellow" }}>{part}</span>
      ) : (
        part
      )
    );
  };

  // Handles search input
  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(0); // Reset to first page on search
  };

  const filteredData = search
  ? managefaqdata
      .map((item) => {
        const matchedFAQListPojo = item.fAQListPojo
          .map((faqGroup) => {
            const filteredFaqs = faqGroup.faqSubCatPojo.filter((faq) =>
              searchInObject(faq, search)
            );
 
            const groupMatches =
              filteredFaqs.length > 0 ||
              searchInObject({ subCat: faqGroup.subCat }, search);
 
            return groupMatches
              ? {
                  ...faqGroup,
                  faqSubCatPojo: filteredFaqs.length > 0 ? filteredFaqs : faqGroup.faqSubCatPojo,
                }
              : null;
          })
          .filter(Boolean); // remove null faqGroup
 
        const itemMatches =
          matchedFAQListPojo.length > 0 || searchInObject(item, search); // now includes grievanceCategory check
 
        return itemMatches
          ? {
              ...item,
              fAQListPojo: matchedFAQListPojo.length > 0 ? matchedFAQListPojo : item.fAQListPojo,
            }
          : null;
      })
      .filter(Boolean) // remove null item
  : managefaqdata;

  // const filteredData = search
  //   ? managefaqdata
  //     .map((item) => {
  //       const matchedFAQListPojo = item.fAQListPojo
  //         .map((faqGroup) => {
  //           const filteredFaqs = faqGroup.faqSubCatPojo.filter((faq) =>
  //             searchInObject(faq, search)
  //           );

  //           const groupMatches =
  //             filteredFaqs.length > 0 ||
  //             searchInObject({ subCat: faqGroup.subCat }, search);

  //           return groupMatches
  //             ? {
  //               ...faqGroup,
  //               faqSubCatPojo: filteredFaqs.length > 0 ? filteredFaqs : faqGroup.faqSubCatPojo,
  //             }
  //             : null;
  //         })
  //         .filter(Boolean); // remove null faqGroup

  //       const itemMatches =
  //         matchedFAQListPojo.length > 0 || searchInObject(item, search);

  //       return itemMatches ? { ...item, fAQListPojo: matchedFAQListPojo } : null;
  //     })
  //     .filter(Boolean) // remove null item
  //   : managefaqdata;

  // Handle edit click
  
  const handleEditClick = (faq, cat, subCat) => {
    setEditingId(faq.faqId);
    setEditValues({
      id: faq.faqId,
      fqaQuestion: faq.questionStr,
      fqaAnswer: faq.answerStr,
      grievanceCategory: cat,
      grevanceSubCategory: subCat,
      isActive: "Y",
      extFlag: 0
    }); // Load current FAQ values into the editing state
  };

  // Handle input change
  const handleChange = (e) => {
    e.preventDefault();
    setEditValues((prevValues) => ({ ...prevValues, [e.target.name]: e.target.value }));
  };

  // console.log("Edit--", editValues)

  // Save changes
  const handleSaveClick = () => {
    setmanagefaqdatapdf((prevList) =>
      prevList.map((faq) =>
        faq.id === editingId ? { ...faq, question: editValues.question, answer: editValues.answer } : faq
      )
    );
    onSaveFAQ();
  };

  // Cancel editing
  const handleCancelClick = () => {
    setEditingId(null); // Exit edit mode without saving
  };

  const handleSelect = (id, sectionIndex) => {
    setSelectedFaqIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
    setExpandedSection({ [sectionIndex]: true });
  };

  const onSaveFAQ = () => {
    setEditingId(null); // Exit edit mode
    handleConfirmLogModalOpen2();
  }

  const onConfirmSubmit2 = () => {
    handleConfirmLogModalClose2();
    EditFaqsById();
  }

  const EditFaqsById = () => {
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/editHelpdeskFrequentAskQuestionById",
      editValues,
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem('id_token')
        }
      }
    ).then((response) => {
      if (response.data.status === "SUCCESS") {
        toast.success(response.data.description);
        managefaq();
        managefaq1();
      }
      else toast.error(response.data.description)
      loaderService.hideLoader();
    }).catch((error) => {
      console.log(error)
      loaderService.hideLoader();
      toast.error('Please try again !')
    })
  }

  const onDeleteFAQ = () => {
    handleConfirmLogModalOpen();
  }

  // const onConfirmSubmit = () => {
  //   handleConfirmLogModalClose();
  //   deleteFAQs();
  // }

  
 
    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await deleteFAQs();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogConfirmModalOpen(false);
            setIsApiCalled(false);
        }
    };

  const deleteFAQs = () => {
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/deleteMultipleHelpdeskFaq",
      {
        "getItemList": selectedFaqIds.map(item => ({ reqId: item.toString() }))
      },
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem('id_token')
        }
      }
    ).then((response) => {
      if (response.data.status === "SUCCESS") {
        toast.success(response.data.description);
        setSelectedFaqIds([]);
        managefaq();
        managefaq1();
      }
      else toast.error(response.data.description)
      loaderService.hideLoader();
    }).catch((error) => {
      console.log(error)
      loaderService.hideLoader();
      toast.error('Please try again !')
    })
  }

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Flatten the FAQ categories for pagination
  const flattenedData = filteredData.flatMap((item, i) =>
    item.fAQListPojo.map((faqGroup, j) => ({
      ...faqGroup,
      parentItem: item,
      sectionIndex: `${i}-${j}`,
    }))
  );

  // Auto-expand sections with matches in header or faqSubCatPojo
  useEffect(() => {
    if (search.trim()) {
      const matches = {};
      const lowerQuery = search.toLowerCase();

      filteredData.forEach((item, i) => {
        item.fAQListPojo.forEach((faqGroup, j) => {
          const sectionIndex = `${i}-${j}`;
          const headerMatch =
            item.grievanceCategory?.toLowerCase().includes(lowerQuery) ||
            faqGroup.subCat?.toLowerCase().includes(lowerQuery);

          const innerMatch = faqGroup.faqSubCatPojo.some(
            (faq) =>
              faq.questionStr?.toLowerCase().includes(lowerQuery) ||
              faq.answerStr?.toLowerCase().includes(lowerQuery)
          );

          if (headerMatch || innerMatch) {
            matches[sectionIndex] = true;
          }
        });
      });

      setExpandedSection(matches);
    } else {
      setExpandedSection({});
      setSelectedFaqIds([]);
    }

    setPage(0);
  }, [search, filteredData]);

  const handleToggleExpand = (index) => {
    setExpandedSection((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  // Apply pagination
  const paginatedData = flattenedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <>
      <Helmet>
        <title> FAQs | ABEPL </title>
      </Helmet>
      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            {t('helpdesk.faqs')}
          </Typography>
          <Button variant="contained" startIcon={<FAQIcon />} onClick={() => { MyDoc() }}> {t('helpdesk.faqDownload')} </Button>
        </Stack>
        <Grid container>
          <Grid item xs={12}>
            {/* Table */}
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell><strong>Category</strong></TableCell>
                    <TableCell><strong>Sub-Category</strong></TableCell>
                    <TableCell>
                      <TextField
                        label="Search"
                        variant="outlined"
                        size='small'
                        fullWidth
                        value={search}
                        onChange={handleSearchChange}
                      /></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedData.map((section) => (
                    <React.Fragment key={section.sectionIndex}>
                      {/* Category Header Row */}
                      <TableRow>
                        <TableCell>
                          <ExpandMoreIcon
                            style={{
                              cursor: "pointer",
                              transform: expandedSection[section.sectionIndex] ? "rotate(180deg)" : "rotate(0deg)",
                              transition: "transform 0.3s",
                            }}
                            onClick={() => handleToggleExpand(section.sectionIndex)}
                          />
                        </TableCell>
                        <TableCell component="th" scope="row">{highlightText(section.parentItem.grievanceCategory, search)}</TableCell>
                        <TableCell >{highlightText(section.subCat, search)}</TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                      {/* Collapsible Row */}
                      <TableRow>
                        <TableCell colSpan={4} style={{ paddingBottom: 0, paddingTop: 0 }}>
                          <Collapse in={expandedSection[section.sectionIndex]} timeout="auto" unmountOnExit>
                            <Table style={{ backgroundColor: "#ffffff" }} >
                              <TableBody>
                                {section.faqSubCatPojo.map((faq) => (
                                  <TableRow key={faq.faqId}>
                                    {editingId === faq.faqId ?
                                      <Grid container spacing={2} mt={1} mb={1}>
                                        <Grid item xs={12} lg={12}>
                                          <TextField fullWidth
                                            label="FAQ"
                                            value={editValues.fqaQuestion}
                                            name='fqaQuestion'
                                            onChange={(e) => handleChange(e)}

                                          />
                                        </Grid>
                                        <Grid item xs={12} lg={12}>
                                          <TextField fullWidth
                                            label="FAQA"
                                            value={editValues.fqaAnswer}
                                            name='fqaAnswer'
                                            onChange={(e) => handleChange(e)} />
                                        </Grid>
                                        <Grid item xs={12} lg={12}>
                                          <Box display='flex' alignItems="center" justifyContent="center">
                                            <Button onClick={(e) => handleSaveClick()} sx={{ minWidth: 120 }} variant="contained" >Submit</Button>
                                            &nbsp;
                                            &nbsp;
                                            <Button onClick={(e) => handleCancelClick()} sx={{ minWidth: 120, mr: 2 }} variant="outlined" >Cancel</Button>
                                          </Box>
                                        </Grid>
                                      </Grid>
                                      : <Grid container spacing={1} mt={(hideEdit === true) ? 0 : 1} mb={1}>
                                        <Grid item xs={2} lg={1} hidden={hideEdit} >
                                          <Checkbox checked={selectedFaqIds.includes(faq.faqId)}
                                            onChange={() => handleSelect(faq.faqId, section.sectionIndex)}
                                          />
                                        </Grid>
                                        <Grid item xs={10} lg={9.5}>
                                          <Typography variant="subtitle2" component="div">FAQ: &nbsp;
                                            <Typography variant="body2" component="label">{highlightText(faq.questionStr, search)}</Typography>
                                          </Typography>
                                          <Typography variant="subtitle2" >
                                            <strong>FAQA: &nbsp;</strong><Typography variant="body2" component="label">{highlightText(faq.answerStr, search)}</Typography>
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={12} lg={1.5} hidden={hideEdit}>
                                          <Button variant='outlined' disabled={selectedFaqIds.includes(faq.faqId)} onClick={(e) => handleEditClick(faq, section.parentItem.grievanceCategory, section.subCat)} startIcon={<EditIcon />}>Edit</Button>
                                        </Grid>
                                      </Grid>}
                                  </TableRow>
                                ))}
                                <Grid item xs={12} lg={12} mb={1} hidden={hideEdit}>
                                  <Box display='flex' alignItems="center" justifyContent="center">
                                    <Button disabled={selectedFaqIds?.length === 0} onClick={(e) => onDeleteFAQ()} variant="outlined" color="error" startIcon={<DeleteIcon />}>Delete</Button>
                                  </Box>
                                </Grid>
                              </TableBody>
                            </Table>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))
                  }
                </TableBody>
              </Table>
              {managefaqdata.length > 0 && (
                < TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={flattenedData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />)}
            </TableContainer>
          </Grid>
        </Grid>
      </Container>
      <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmSubmit} onClose={handleConfirmLogModalClose} action="Delete FAQ" />
      <ConfirmationPopover onOpen={logConfirmModalOpen2} onConfirm={onConfirmSubmit2} onClose={handleConfirmLogModalClose2} action="Submit FAQ" />
    </>

  );
}

export default ReportsPage